import InstagramIcon from '@mui/icons-material/Instagram';
import LaunchIcon from '@mui/icons-material/Launch';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import GradientHeading from 'components/GradientHeading';
import { InstagramEmbed } from 'react-social-media-embed';

const Instagram = () => {
    const theme = useTheme();

    const instagramPosts = ['https://www.instagram.com/p/DP3bRHRAToD/'];

    const instagramUrl = 'https://www.instagram.com/pokjaaccperki';

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
            <Box sx={{ textAlign: 'center', mb: 8 }}>
                <GradientHeading label="Stay Connected" />

                <Typography
                    variant="h5"
                    sx={{
                        color: theme.palette.text.secondary,
                        mb: 4,
                        fontSize: { xs: '1.2rem', md: '1.5rem' },
                        fontWeight: 500,
                        maxWidth: 600,
                        mx: 'auto',
                    }}
                >
                    Follow our latest updates, events, and behind-the-scenes
                    content on Instagram
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<InstagramIcon />}
                    endIcon={<LaunchIcon />}
                    href={instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        background: `linear-gradient(45deg, #E4405F, #C13584)`,
                        color: 'white',
                        fontWeight: 600,
                        px: 4,
                        py: 1.5,
                        borderRadius: 3,
                        textTransform: 'none',
                        fontSize: '1rem',
                        boxShadow: '0 8px 25px rgba(228, 64, 95, 0.3)',
                        '&:hover': {
                            background: `linear-gradient(45deg, #C13584, #E4405F)`,
                            transform: 'translateY(-2px)',
                            boxShadow: '0 12px 35px rgba(228, 64, 95, 0.4)',
                        },
                    }}
                >
                    Join us on Instagram
                </Button>
            </Box>

            <Grid container spacing={4} justifyContent="center">
                {instagramPosts.map((postUrl, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        key={index}
                        data-aos="fade-up"
                        data-aos-delay={index * 100}
                        data-aos-offset={100}
                        data-aos-duration={600}
                    >
                        <Card
                            sx={{
                                borderRadius: 4,
                                overflow: 'hidden',
                                background: 'white',
                                border: `2px solid ${theme.palette.divider}`,
                                transition:
                                    'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                                    border: `2px solid #E4405F40`,
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    '& .instagram-media': {
                                        borderRadius: '0 !important',
                                        border: 'none !important',
                                        boxShadow: 'none !important',
                                        margin: '0 !important',
                                    },
                                }}
                            >
                                <InstagramEmbed
                                    url={postUrl}
                                    width="100%"
                                    captioned={false}
                                />
                            </Box>
                        </Card>
                    </Grid>
                ))}

                {/* Add More Posts Placeholder */}
                {instagramPosts.length < 4 && (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            sx={{
                                height: 400,
                                borderRadius: 4,
                                border: `2px dashed ${theme.palette.divider}`,
                                background: `linear-gradient(135deg, ${theme.palette.grey[50]}, ${theme.palette.grey[100]})`,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: 4,
                                transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                    border: `2px dashed #E4405F`,
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 80,
                                    height: 80,
                                    borderRadius: '50%',
                                    background: `linear-gradient(45deg, #E4405F20, #C1358440)`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 3,
                                }}
                            >
                                <InstagramIcon
                                    sx={{ fontSize: 40, color: '#E4405F' }}
                                />
                            </Box>

                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 600,
                                    mb: 2,
                                    color: theme.palette.text.secondary,
                                    textAlign: 'center',
                                }}
                            >
                                More Posts Coming
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: theme.palette.text.secondary,
                                    textAlign: 'center',
                                    maxWidth: 200,
                                    mb: 3,
                                }}
                            >
                                Follow us on Instagram for the latest updates
                                and event highlights
                            </Typography>

                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<InstagramIcon />}
                                href={instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    borderColor: '#E4405F',
                                    color: '#E4405F',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    '&:hover': {
                                        background: '#E4405F',
                                        color: 'white',
                                        borderColor: '#E4405F',
                                    },
                                }}
                            >
                                Follow
                            </Button>
                        </Card>
                    </Grid>
                )}
            </Grid>
        </Container>
    );
};

export default Instagram;
